import { createContext, useContext, useState } from "react";

const LANG_KEY = "rang1_lang";

const detectLang = () => {
  const saved = localStorage.getItem(LANG_KEY);
  if (saved === "fr" || saved === "en") return saved;
  return (navigator.language || "en").toLowerCase().startsWith("fr") ? "fr" : "en";
};

const LangContext = createContext({ lang: "en", setLang: () => {} });

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(detectLang);
  const setLang = (l) => {
    localStorage.setItem(LANG_KEY, l);
    setLangState(l);
    document.documentElement.lang = l;
  };
  return <LangContext.Provider value={{ lang, setLang }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
